/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationResultNewDeviceMetadataStruct
 */
export interface AuthenticationResultNewDeviceMetadataStruct {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResultNewDeviceMetadataStruct
     */
    deviceGroupKey: string;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResultNewDeviceMetadataStruct
     */
    deviceKey: string;
}

/**
 * Check if a given object implements the AuthenticationResultNewDeviceMetadataStruct interface.
 */
export function instanceOfAuthenticationResultNewDeviceMetadataStruct(value: object): value is AuthenticationResultNewDeviceMetadataStruct {
    if (!('deviceGroupKey' in value) || value['deviceGroupKey'] === undefined) return false;
    if (!('deviceKey' in value) || value['deviceKey'] === undefined) return false;
    return true;
}

export function AuthenticationResultNewDeviceMetadataStructFromJSON(json: any): AuthenticationResultNewDeviceMetadataStruct {
    return AuthenticationResultNewDeviceMetadataStructFromJSONTyped(json, false);
}

export function AuthenticationResultNewDeviceMetadataStructFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationResultNewDeviceMetadataStruct {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceGroupKey': json['deviceGroupKey'],
        'deviceKey': json['deviceKey'],
    };
}

export function AuthenticationResultNewDeviceMetadataStructToJSON(json: any): AuthenticationResultNewDeviceMetadataStruct {
    return AuthenticationResultNewDeviceMetadataStructToJSONTyped(json, false);
}

export function AuthenticationResultNewDeviceMetadataStructToJSONTyped(value?: AuthenticationResultNewDeviceMetadataStruct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deviceGroupKey': value['deviceGroupKey'],
        'deviceKey': value['deviceKey'],
    };
}

